exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".odemeyap[data-v-ed364138]{margin-bottom:20px;border:1px solid #ebeef5;padding:10px}.odemeyap h5[data-v-ed364138]{font-size:12px;text-align:center;background:#ebeef5;padding:5px}iframe[data-v-ed364138]{width:100%;border:none;height:700px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed364138","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Genel/Hesap.vue
// module id = 633
// module chunks = 0